import { useToggleMeditationLike } from "../../application/useMeditations";
import { Meditation, MeditationVisibility } from "../../domain/types";
import LikeHeart from "./LikeHeart";

type Props = {
    meditation: Meditation;
};

/**
 * The heart on a published meditation, and how many therapists gave one.
 *
 * Nothing on a private one: a like is a therapist telling the others "this
 * works", and nobody else sees a private meditation to be told.
 */
export default function MeditationLikeButton({ meditation }: Props) {
    const toggle = useToggleMeditationLike();

    if (meditation.visibility !== MeditationVisibility.PUBLIC) return null;

    return (
        <LikeHeart
            liked={Boolean(meditation.liked_by_me)}
            count={meditation.like_count ?? 0}
            onToggle={() => toggle.mutate(meditation)}
            pending={toggle.isPending}
            readOnly={meditation.is_owner}
        />
    );
}
